import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { useStyles, GreenCheckbox, BlueZoomInIcon } from "./styles";
import { DEBITO_QUITADO } from "../../helper/resources/Constants";
import ModalCardDebit from "../ModalCardDebit";
import { ListDebitContent } from "../ListDebitContent";

function ListDebitComponent(props) {
  const classes = useStyles();
  const [isHovered, toggleHover] = useState(false);
  const [isChecked, toggleChecked] = useState(props.contentCard.CheckedDebt);
  const [state, setState] = React.useState({
    idItem: props.contentCard.CheckedDebt || false,
  });
  const [openModal, setOpenModal] = React.useState(false);

  const itemId =
    props.typeCard === "tribute"
      ? props.contentCard.IdItem
      : props.contentCard.IdDebito;

  const { checkDebts, contentCard, selectionModeActive } = { ...props };
  const checkedDebt = contentCard.CheckedDebt;

  useEffect(() => {
    setState((prevState) => ({ ...prevState, idItem: checkedDebt }));
    toggleChecked(checkedDebt);
  }, [checkDebts, checkedDebt, setState, toggleChecked]);

  useEffect(() => {
    if (!openModal) toggleHover(false);
  }, [openModal]);

  const handleCheckbox = (name, checked, id) => {
    if (props.contentCard.CodigoSituacao === DEBITO_QUITADO) return;

    setState({ ...state, [name]: checked });
    toggleChecked(!isChecked);

    props.handleGetCardSelected(id, checked);
  };

  function handleClickOpen() {
    if (props.contentCard.Contribuinte !== null) setOpenModal(true);
    else setOpenModal(false);
  }

  const checkDateDebit = (cardContent) => {
    let dividaQuitada = cardContent.CodigoSituacao === DEBITO_QUITADO

    if(dividaQuitada)
        return false;

    var date = new Date();
    var hoje = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    let partsDataVencimentoDiaUtil = null;
    let partsDataVencimento = cardContent.DataVencimento?.split("/");

    if (cardContent.DataVencimentoDiaUtil === null) {
      cardContent.DataVencimentoDiaUtil = cardContent.DataVencimento;
      partsDataVencimentoDiaUtil =
        cardContent.DataVencimentoDiaUtil?.split("/");
    } else
      partsDataVencimentoDiaUtil =
        cardContent.DataVencimentoDiaUtil?.split("-");

    var DataVencimento = new Date(
      partsDataVencimento[2],
      partsDataVencimento[1] - 1,
      partsDataVencimento[0]
    );

    var DataVencimentoDiaUtil = new Date(
      partsDataVencimentoDiaUtil[0],
      partsDataVencimentoDiaUtil[1] - 1,
      partsDataVencimentoDiaUtil[2] !== undefined
        ? partsDataVencimentoDiaUtil[2].substring(0, 2)
        : null
    );

    if (
      hoje.valueOf() >= DataVencimento.valueOf() &&
      hoje.valueOf() >= DataVencimentoDiaUtil.valueOf()
    )
      return true;

    return false;
  };

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      className={classes.cardItem}
      data-testid="card-debit"
    >
      <div
        className={`
        ${classes.cardItemContent}
        ${isChecked && classes.cardSelected}
        ${checkDateDebit(props.contentCard) && classes.listStatusDebtLate}
        ${props.contentCard.Ocultado && classes.rootHiddenDebt }`}
        onMouseOver={() => toggleHover(true)}
        onMouseLeave={() => toggleHover(false)}
      >
        <div className={` ${classes.actionList} `}>
          {props.typeCard !== "dam" && (
            <div
              className={`${classes.itemCheckbox} ${
                (isHovered || isChecked || selectionModeActive) &&
                props.contentCard.CodigoSituacao !== DEBITO_QUITADO &&
                classes.showCheckbox
              }`}
            >
              <GreenCheckbox
                checked={state?.idItem}
                onChange={(e) =>
                  handleCheckbox("idItem", e.target.checked, e.target.value)
                }
                value={itemId}
                inputProps={{
                  "aria-label": "primary checkbox",
                  "data-testid": "checkbox-select-debit",
                }}
              />
            </div>
          )}
        </div>
        <ListDebitContent
          typeDebit={props.typeDebit}
          contentCard={props.contentCard}
          selectionModeActive={selectionModeActive}
          handleClickSelect={() =>
            handleCheckbox("idItem", !state.idItem, itemId)
          }
          handleClickOpen={handleClickOpen}
        />
        <div className={`${classes.zoomIn}`}>
          <div
            className={`${classes.itemZoomIn} ${
              isHovered && selectionModeActive && classes.showZoomIn
            }`}
          >
            <BlueZoomInIcon onClick={handleClickOpen} />
          </div>
          {openModal && (
            <ModalCardDebit
              propsParent={props}
              openModal={openModal}
              setOpenModal={setOpenModal}
            />
          )}
        </div>
      </div>
    </Grid>
  );
}

export const ListDebit = React.memo(ListDebitComponent)
